<template>
  <div>
    <el-button type="primary" size="mini" @click="AddRole" class="elinput"
      v-if="Permission.indexOf(23) != -1">{{ $t('lang.Authoritymanagement.Add') }}</el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem" v-if="Permission.indexOf(132) != -1"></xlsx>
    <!--    表格-->
    <TableComponent :data="data" :RowKey="'roleId'" :DeleteTitle="$t('lang.Authoritymanagement.addinganewrole')"
      :ColuumnsButtonWidth="140" :Columns="Columns" :ColuumnsButton="ColuumnsButton" :seek="seek"
      @setroleIdsetjurisdiction="setroleIdsetjurisdiction" @deleteRole="deleteRole" @sortChange="sortChange"
      @GetStatus="GetStatus" @GetCname="GetCname" />
    <!--分页-->
    <pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"></pagination>
    <!-- 修改 -->
    <set-role ref="setRole"></set-role>
    <!-- 添加 -->
    <add-user-role ref="addRole" @getFunctionalAuthority="queryKeyword"></add-user-role>
  </div>
</template>

<script>
// 权限列表数据比较麻烦，需要多层循环
import {
  showFunctionList,
  getRoleOwnFunction,
  modifyRoleFunction,
  deleteRole,
  addRole,
  modifyRoleNameAndDescription,
  queryKeyword
} from "@/api/Authoritymanagement";
import xlsx from "@/components/xlsx";
import pagination from "@/components/pagination";
import DeleteBox from "@/components/DeleteBox";
import { getPermission } from "../../../cookie/cookie";
import { PublicComponent } from "../../../mixins/common";
import { mapGetters } from "vuex";
import TableComponent from '@/components/TableComponent/index'
import { Columns, ColuumnsButton } from './TableConfig'
import setRole from './components/setRole'
import addUserRole from './components/addRole'
export default {
  mixins: [PublicComponent],
  name: 'Authoritymanagement',
  activated() {
    //获取权限列表
    this.Permission = getPermission();
    //获取角色列表
    this.queryKeyword()
  },
  mounted() {
    //获取权限列表
    this.Permission = getPermission();
    //获取角色列表
    this.queryKeyword()
  },
  data() {
    return {
      Columns: Columns,
      ColuumnsButton: ColuumnsButton,
      //权限数组
      Permission: [],
      centerDialogVisible: false,
      centerDialogVisible1: false,
      data: [],
      //树形菜单列表
      TreeData: [],
      //修改角色名，角色描述
      setuser: {
        roleName: '',
        roleDescription: '',
        roleId: ''
      },
      adduser: {
        role_name: "",
        role_description: "",
        functionList: []
      },
      //权限树形控件显示字段
      defaultProps: {
        children: 'functionList',
        label: 'functionName'
      },
      //搜索框绑定
      seek: {
        //创建者
        userNickname: "",
        //身份名称
        roleName: "",
        //描述
        roleDescription: "",
        //状态
        roleStatus: "",
        customer: "", //归属客户
        roleCreate: "" //创建时间
      },
      //表格排序
      sort: {
        rolename: null, //角色名称
        description: null, //描述
        status: null, //状态
        create: null, //创建者
        cname: null, //归属客户
        craetetime: null //创建时间
      }
    };
  },
  components: {
    pagination,
    xlsx,
    DeleteBox,
    TableComponent,
    setRole,
    addUserRole
  },
  methods: {
    //弹出添加窗口
    AddRole() {
      this.$refs.addRole.show()
    },
    setroleIdsetjurisdiction(row) {
      this.$refs.setRole.show(row)
    },
    //删除列表角色
    deleteRole(row) {
      deleteRole(row.roleId).then(res => {
        if (res.data.code === 0) {
          this.$message({
            message: this.$t("lang.Authoritymanagement.deleteDir"),
            type: "success"
          });
          this.queryKeyword()
        } else {
          this.$message({
            message: this.$t("lang.Authoritymanagement.intbdb_delete"),
            type: "warning"
          });
          this.queryKeyword()
        }
      });
    },
    //输入框搜索
    queryKeyword() {
      queryKeyword(
        this.offset,
        this.limit,
        [
          this.seek.roleName,
          this.seek.roleDescription,
          this.seek.roleStatus,
          this.seek.userNickname,
          this.seek.customer,
          this.seek.roleCreate
        ],
        this.sort,
        this.$i18n.locale == "en-US" ? 1 : 0
      ).then(res => {
        this.total = res.data.data.total;
        this.limit = res.data.data.limit;
        this.offset = res.data.data.offset;
        this.data = res.data.data.list;
        this.data.unshift({});
      });
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        rolename: null,
        description: null,
        status: null,
        create: null,
        cname: null,
        craetetime: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.Authoritymanagement.Character")) {
        this.sort.rolename = sortlist;
      } else if (label == this.$t("lang.Authoritymanagement.describe")) {
        this.sort.description = sortlist;
      } else if (label == this.$t("lang.Authoritymanagement.statevoid")) {
        this.sort.status = sortlist;
      } else if (label == this.$t("lang.Authoritymanagement.Creator")) {
        this.sort.create = sortlist;
      } else if (label == this.$t("lang.Authoritymanagement.belonging")) {
        this.sort.cname = sortlist;
      } else if (label == this.$t("lang.Authoritymanagement.Creation")) {
        this.sort.craetetime = sortlist;
      }
    },
    //权限状态
    GetStatus(status) {
      return { status: 'success', TagName: '正常' }
    },
    //归属客户
    GetCname(row) {
      return row.customer ? row.customer.c_name : ''
    }
  }
};
</script>

<style scoped>
.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}

/*隐藏多选框lab文字*/
/*误删除*/
.el-checkbox__input.is-checked .el-checkbox__label {
  display: none;
}

.el-checkbox__label {
  display: none;
}

.tabletitle {
  width: 100%;
  height: 0.8rem;
  font-size: 0.25rem;
  line-height: 0.8rem;
  background-color: #4284da;
  color: #ffffff;
  text-indent: 0.5rem;
}

.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}

.spanov {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.25rem;
  height: 41px;
  display: block;
  line-height: 41px;
}

.tetxp {
  display: inline-block;
  width: 2.8rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
</style>
